import React, { useState } from "react";
import { C } from "../constants/baziData";

const SHISHEN_MEANING = {
  "比肩": "独立自信，自力更生，竞争意识强",
  "劫财": "合作共事，财运起伏，感情多波折",
  "食神": "才华福气，口才出众，享受生活",
  "伤官": "聪明叛逆，才华横溢，不拘一格",
  "偏财": "偏门财运，广交人际，父缘一般",
  "正财": "务实理财，感情专一，正当收入",
  "七杀": "压力动力，竞争激烈，破坏中建设",
  "正官": "循规蹈矩，名誉地位，责任心强",
  "偏印": "偏门学问，宗教缘深，思维独特",
  "正印": "学识渊博，贵人运强，母缘深厚",
};

const SHISHEN_COLORS = {
  "比肩": "#2D6A4F", "劫财": "#40916C",
  "食神": "#B91C1C", "伤官": "#DC2626",
  "偏财": "#A07820", "正财": "#C9A84C",
  "七杀": "#6B7280", "正官": "#9CA3AF",
  "偏印": "#1E3A8A", "正印": "#3B82F6",
};

const PILLAR_LABELS = { year: "年柱", month: "月柱", day: "日柱", hour: "时柱" };

function ShishenCard({ name, pillars, meaning, color }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{
      border: "1px solid rgba(212,175,55,.20)",
      borderRadius: 10,
      marginBottom: 8,
      overflow: "hidden",
    }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display: "flex", alignItems: "center", gap: 10,
          padding: "12px 16px",
          background: "rgba(212,175,55,.04)",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <span style={{
          width: 10, height: 10, borderRadius: "50%",
          background: color, flexShrink: 0,
        }}/>
        <span style={{ fontSize: 16, fontWeight: 600, color: "#333", flex: 1 }}>{name}</span>
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          {pillars.map(p => (
            <span key={p} style={{
              fontSize: 10, borderRadius: 12,
              padding: "2px 8px",
              background: "rgba(212,175,55,.10)",
              color: "#846B32",
              border: "1px solid rgba(212,175,55,.25)",
            }}>{p}</span>
          ))}
        </div>
        <span style={{
          fontSize: 12, color: "#9A8070", marginLeft: 6,
          transform: open ? "rotate(180deg)" : "none",
          transition: "transform .2s",
          display: "inline-block",
        }}>▼</span>
      </div>
      <div style={{
        maxHeight: open ? 120 : 0,
        overflow: "hidden",
        transition: "max-height .25s ease",
      }}>
        <div style={{
          padding: "12px 16px",
          fontSize: 13, color: "#4A3A2A", lineHeight: 1.8,
          borderTop: "1px solid rgba(212,175,55,.10)",
        }}>
          {meaning || "—"}
        </div>
      </div>
    </div>
  );
}

function ShishenCards({ shishen_full, daymaster, lang }) {
  if (!shishen_full || Object.keys(shishen_full).length === 0) return null;

  // Collect unique ten-gods (excluding 日主)
  const godMap = {};
  for (const [pillar, data] of Object.entries(shishen_full)) {
    const label = PILLAR_LABELS[pillar] || pillar;
    for (const field of ["stem_shishen", "branch_shishen"]) {
      const god = data?.[field];
      if (god && god !== "日主") {
        if (!godMap[god]) godMap[god] = [];
        if (!godMap[god].includes(label)) godMap[god].push(label);
      }
    }
  }

  const gods = Object.entries(godMap);
  if (gods.length === 0) return null;

  return (
    <div>
      <div style={{
        fontSize: 12, color: "#9A8070", marginBottom: 14,
        fontFamily: "sans-serif",
      }}>
        {lang === "zh"
          ? "点击展开每个十神的能量特征与实际影响"
          : "Tap to expand each Ten-God's energy profile"}
      </div>
      {gods.map(([name, pillars]) => (
        <ShishenCard
          key={name}
          name={name}
          pillars={pillars}
          meaning={SHISHEN_MEANING[name] || "—"}
          color={SHISHEN_COLORS[name] || C.gold}
        />
      ))}
    </div>
  );
}

export default ShishenCards;
